import { Loading, Title } from "@components";

import EngagementGroups from "./EngagementGroups";
import EngagementBehavior from "./EngagementBehavior";
import { useEffect, useState } from "react";
import { ReportsAPI } from "providers/ReportsAPI";
import { If } from "shared/components/control-statements";

export default function Index() {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    const provider = new ReportsAPI();
    const response = await provider.loyaltyEngagements();

    setData(response);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const program = localStorage.getItem("cashbackProgram")
    ? JSON.parse(localStorage.getItem("cashbackProgram"))
    : null;

  const isCashback = program?.type !== "POINT";

  return (
    <>
      <Title
        title="Engajamento"
        backTo={{
          url: "/relatorios/fidelizacao",
          name: "Fidelização",
        }}
      />

      <If cond={loading}>
        <Loading fullContent />
      </If>

      <EngagementGroups data={data.groups} isCashback={isCashback} />
      <EngagementBehavior data={data.behavior} isCashback={isCashback} />
    </>
  );
}
